// extracted by mini-css-extract-plugin
module.exports = {"dialog":"PDialog_dialog__E3DBD","dialogBackground":"PDialog_dialogBackground__2QL-M"};